import type { ClientFormValues } from '@oficina/shared';
import { api } from '@/lib/api';
import type {
  Client,
  ClientDetail,
  ClientMaintenanceEntry,
  Equipment,
  OrderSummary,
  Paginated,
  RemovalResult,
} from '@/types/api';

export interface ClientListParams {
  search?: string;
  page?: number;
  pageSize?: number;
  includeInactive?: boolean;
}

export interface CepResult {
  zip: string;
  street: string | null;
  neighborhood: string | null;
  city: string | null;
  state: string | null;
}

export const clientsService = {
  list: (params: ClientListParams, signal?: AbortSignal) =>
    api.get<Paginated<Client>>('/clients', { ...params }, signal),
  cep: (cep: string) =>
    api.get<CepResult>(`/clients/cep/${cep.replace(/\D/g, '')}`),
  get: (id: string) => api.get<ClientDetail>(`/clients/${id}`),
  create: (input: ClientFormValues) => api.post<Client>('/clients', input),
  update: (id: string, input: Partial<ClientFormValues>) => api.patch<Client>(`/clients/${id}`, input),
  remove: (id: string, hard = false) => api.delete<RemovalResult>(`/clients/${id}`, { hard }),
  reactivate: (id: string) => api.post<Client>(`/clients/${id}/reactivate`),
  equipment: (id: string, includeInactive = false) =>
    api.get<Equipment[]>(`/clients/${id}/equipment`, { includeInactive }),
  orders: (id: string) => api.get<OrderSummary[]>(`/clients/${id}/service-orders`),
  maintenance: (id: string) => api.get<ClientMaintenanceEntry[]>(`/clients/${id}/maintenance-history`),
};
